import { AWSAppSyncClient } from 'aws-appsync'
import awsConfiguration from "../awsconfiguration"

class client {
    static get api() {
        const appclient = new AWSAppSyncClient({
            url: awsConfiguration().ApiUrl,
            region: awsConfiguration().Region,
            disableOffline: true,
            auth: {
                type: awsConfiguration().AuthMode,
                apiKey: awsConfiguration().ApiKey
            }
        }, {
            defaultOptions: {
                query: {
                    fetchPolicy: 'no-cache',
                    errorPolicy: 'none'
                }
            }
        });

        return appclient;
    }
}

export default client;

